import styled from 'styled-components';
import { timingDefault } from '../../constants';
export const Summary = styled.button `
  align-items: center;
  display: flex;
  justify-content: space-between;
  outline-offset: -1px;
  cursor: pointer;
  line-height: 1;
  letter-spacing: unset;
  width: 100%;
`;
export const Details = styled.div `
  display: grid;
  /* Ariakit will automatically wait until 'onAnimationEnd' is called before visually hiding the details panel. */
  transition: ${o => (o.$animate ? `grid-template-rows ${timingDefault} ease` : 'none')};

  /* Emulate transition from '0' -> 'auto' height on enter/leave */
  grid-template-rows: ${o => (o.$animate ? '0fr' : '1fr')};
  &[data-enter] {
    grid-template-rows: 1fr;
  }
`;
export const DetailsContent = styled.div `
  overflow: hidden;
  padding: 0;
`;
//# sourceMappingURL=styles.js.map